import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {WPPostGuide} from '../../../types/WPPostGuide';

@Component({
  selector: 'app-guide-puffs-list',
  templateUrl: './guide-puffs-list.component.html',
  styleUrls: ['./guide-puffs-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GuidePuffsListComponent {
  puffs = input<WPPostGuide[]>([]);
  numberOfPriorityPuffs = input<number>(1);
}
